import type { AnchorHTMLAttributes, ReactNode } from 'react'

interface NavItemProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  children: ReactNode
}

export function NavItem({ children, className = '', ...props }: NavItemProps) {
  return (
    <a
      className={`flex items-center py-3 border-b border-[rgba(128,128,128,0.12)] text-sm font-semibold tracking-wider text-ink dark:text-dark-ink hover:text-cyan dark:hover:text-cyan transition-colors ${className}`}
      {...props}
    >
      {children}
    </a>
  )
}
